// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".venues-list[data-v-0ad9f7e0]{margin-top:30px}.venues-list__title[data-v-0ad9f7e0]{text-align:center;padding:15px;font-size:20px}.venues-list__title-left[data-v-0ad9f7e0]{text-align:left;padding:30px 0 30px 5px}.venues-list__list[data-v-0ad9f7e0]{display:flex;flex-wrap:wrap;justify-content:center}", ""]);
// Exports
module.exports = exports;
